import i18next, { type TOptions } from "i18next";

import ko from "./generated/ko.json";
import en from "./generated/en.json";
import { Preferences } from "@capacitor/preferences";

export type Language = "ko" | "en";
const LANGUAGE_KEY = "monspot_language";

function getDeviceLanguage(): Language {
  const deviceLanguage = navigator.language.toLowerCase();

  if (deviceLanguage.startsWith("ko")) return "ko";

  return "en";
}

export async function initI18n(language?: Language) {
  const initialLanguage = language ?? (await getSavedLanguage());

  await i18next.init({
    lng: initialLanguage,
    fallbackLng: "en",

    resources: {
      ko: {
        translation: ko,
      },
      en: {
        translation: en,
      },
    },

    interpolation: {
      escapeValue: false,
    },
  });
}

export function t(key: string, options?: TOptions) {
  return i18next.t(key, options);
}

export async function changeLanguage(language: Language) {
  await setLanguage(language);
}

export function getCurrentLanguage() {
  return i18next.language;
}

export async function getSavedLanguage(): Promise<Language> {
  const { value } = await Preferences.get({ key: LANGUAGE_KEY });

  if (value === "ko" || value === "en") return value;

  const detectedLanguage = getDeviceLanguage();

  await Preferences.set({
    key: LANGUAGE_KEY,
    value: detectedLanguage,
  });

  return detectedLanguage;
}

export async function setLanguage(language: Language) {
  await Preferences.set({
    key: LANGUAGE_KEY,
    value: language,
  });

  await i18next.changeLanguage(language);
}
